export default __webpack_public_path__ + "static/media/mn_tea_sub_3.7d8f760b.png";